export default {
  id: 'company-benefits',
  title: 'Company Benefits',
  category: 'Admin',
  summary: 'Define the benefit offerings available to employees across the company.',
  overview: 'Company Benefits maintains the catalog of benefit definitions. Employee benefit assignments and settings tables reference these definitions.',
  howItWorks: [
    'Administrators create and edit benefit definitions.',
    'Those definitions become available when configuring employee benefits.',
    'Changes affect how benefits appear in admin employee views and related calculations.'
  ],
  actions: [
    {
      name: 'Add / edit benefit',
      description: 'Opens a modal to create or update a company benefit definition.'
    }
  ],
  tips: [
    'Align benefit names with how they are discussed in offer letters and payroll for easier reconciliation.'
  ],
  related: ['settings', 'employees']
};



// WEBPACK FOOTER //
// ./client/help/content/company-benefits.js